import React from 'react';

const CastleIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M5 17h2v2h2v-2h2v2h2v-2h2v2h2v-5l3-3V5h2l4 2-4 2v2l3 3v12H14v-3a2 2 0 1 0-4 0v3H5v-9m16-3c-.55 0-1 .54-1 1.2V17h2v-1.8c0-.66-.45-1.2-1-1.2z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default CastleIcon;
